import { render, staticRenderFns } from "./SecurityModal.vue?vue&type=template&id=05d3c766&"
import script from "./SecurityModal.vue?vue&type=script&lang=js&"
export * from "./SecurityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports